<template>
  <div
    v-if="updater.newVersionAvailable"
    class="update-message"
    @click="update"
  >
    New version is ready, click here to switch!
  </div>
</template>
<script>
import {updater} from './updater.ts';


export default {
  data() {
    return {
      updater,
    }
  },
  methods: {
    update() {
      location.reload(true);
    }
  }
}
</script>
<style>
.update-message {
  text-align: center;
  background-color: var(--f7-theme-color);
  color: #fff;
  font-weight: 700;
  padding: 30px 20px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 11000;
}
</style>